import React from "react";
import Categories from './index'
import UnconfiguredComponent from '../common3/UnconfiguredComponent'

import isEmpty from 'lodash/isEmpty'

const CategoriesEdit = (props) => {
  const { extra = {},builder = false } = props;
  const { categories = [] } = extra;

  if( builder && isEmpty(categories)) {
    return <UnconfiguredComponent hint='Add categories'/>
  }

  return <Categories {...props}/>
};

export default CategoriesEdit